import { testimonials } from '@/mocks/faqs';

export default function Reputation() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-secondary-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-accent-500 tracking-widest mb-2">
            ✦ TESTIMONIALS ✦
          </p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            听听嫩小兔的粉丝们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}